import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';
import { VoziloView } from 'src/app/lookups/vozilo/vozilo-view';
import { BaseDataService, ConfirmationDialogButtons, ModalService, MultiselectComponent, NotificationService, QueryParameter } from 'yt-ng-framework';

@Component({
  selector: 'yt-gabariti-robe',
  templateUrl: './gabariti-robe.component.html'
})
export class GabaritiRobeComponent implements OnInit {

  constructor(
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    private datePipe: DatePipe,
    protected modalService: ModalService
  )
  {    
    
  }
  initialFormValue: any;
  brojVozila: Number;

  @Input() Parameters: QueryParameter[];
  napomenaPrazna: boolean = true;
  @ViewChild("multiselectComponent", { static: true }) multiselectComponent: MultiselectComponent<VoziloView>;
  

ngOnInit() {
  
  this.formGroup.patchValue({TezinaNeto: this.Parameters[0].Value});
  this.formGroup.patchValue({TezinaNetoJedinicaMereId: this.Parameters[1].Value});
  this.formGroup.patchValue({TezinaBruto: this.Parameters[2].Value});
  this.formGroup.patchValue({TezinaBrutoJedinicaMereId: this.Parameters[3].Value});
  this.formGroup.patchValue({Zapremina: this.Parameters[4].Value});
  this.formGroup.patchValue({ZapreminaJedinicaMereId: this.Parameters[5].Value});
  this.formGroup.patchValue({PakovanjeVrsta: this.Parameters[6].Value});
  this.formGroup.patchValue({PakovanjeKolicina: this.Parameters[7].Value});

  this.formGroup.patchValue({Pozicija: this.Parameters[8].Value});
  this.formGroup.patchValue({Crm: this.Parameters[9].Value});
  this.formGroup.patchValue({VozilaIds: this.Parameters[10].Value});
  this.formGroup.patchValue({Vozac: this.Parameters[11].Value});
  this.formGroup.patchValue({NapomenaTransporteri: this.Parameters[12].Value});
  this.baseUpdateID = Number(this.Parameters[13].Value);
  if (this.Parameters[14].Value)
    this.formGroup.disable();
  else
    this.formGroup.enable();

  if (this.Parameters[12].Value){
    if (this.Parameters[12].Value.toString().trim()){
      this.napomenaPrazna = false;
    }
    else{
      this.formGroup.get('NapomenaTransporteri').setValue(this.Parameters[12].Value.toString().trim());
    } 
  }
  
  this.brojVozila = 0;
  if (this.Parameters[10].Value){
    this.brojVozila = this.Parameters[10].Value.toString().split(",").map(x=>x.trim()).filter(x=>x!=="").length;
  }

  this.initialFormValue = this.formGroup.getRawValue();

}

baseUpdateID: number;

formGroup = new FormGroup({
  TezinaNeto: new FormControl(),
  TezinaNetoJedinicaMereId: new FormControl(),
  TezinaBruto: new FormControl(),
  TezinaBrutoJedinicaMereId: new FormControl(),
  Zapremina: new FormControl(),
  ZapreminaJedinicaMereId: new FormControl(),
  PakovanjeVrsta: new FormControl(),
  PakovanjeKolicina: new FormControl(),
  Pozicija: new FormControl(),
  Crm: new FormControl(),
  VozilaIds: new FormControl(),
  Vozac: new FormControl(),
  NapomenaTransporteri: new FormControl()
})

Save(){
  this.activeModal.close(
    this.formGroup.getRawValue()
    
  )
  // this.notificationService.info( 'Dodatna polja', 'Uspešno dopisani podaci na tekući dokument.')
  this.toastrService.info( 'Dodatna polja', 'Uspešno dopisani podaci na tekući dokument.');

}

Close() {
  const currentValue = this.formGroup.getRawValue();
  const isChanged = JSON.stringify(currentValue) !== JSON.stringify(this.initialFormValue);
  
  if (isChanged) {
    this.modalService.ShowConfirmationDialog(
      "Obaveštenje",
      "Postoje promene u tekućim podacima. Akcijom koju ste pokrenuli promene neće biti sačuvane.",
      "question",
      ConfirmationDialogButtons.ConfirmCancel
    ).result.then((result) => {
      if (result === ConfirmationDialogButtons.ConfirmCancel || result === true) {
        this.activeModal.dismiss();
      }
    }).catch(() => {});
  } else {
    this.activeModal.dismiss();
  }
}


      trenutniBrojVozila: Number = 0;
      napomenaTransporteri: string = "";
      DajStavkeVozila(items) {
        this.trenutniBrojVozila = items.toString().split(",").map(x=>x.trim()).filter(x=>x!=="").length;

        if (!this.VozilaItems || !Array.isArray(this.VozilaItems)) {
          return;
        }

        // if (this.napomenaPrazna ) {
        if (this.trenutniBrojVozila>this.brojVozila) {
            // this.napomenaTransporteri = "";
            this.napomenaTransporteri = this.formGroup.get('NapomenaTransporteri').value;

            let niz = [];
            if (Array.isArray(items)) {
                niz = items;
            } else if (typeof items === 'string') {
                niz = items.split(",");
            } else if (typeof items === 'number') {
                niz = [items]; 
            }
    
            niz.forEach(item1 => {
                // const foundVozilo = this.VozilaItems.find(item => item.ID == Number(item1));
                const foundVozilo = this.multiselectComponent.items1.find(item => item.ID == Number(item1));
                if (foundVozilo) {
                    if (!this.napomenaTransporteri || (this.napomenaTransporteri && !this.napomenaTransporteri.toLowerCase().includes(foundVozilo.Naziv.trim().toLowerCase()))){     
                      if (this.napomenaTransporteri == null)
                        this.napomenaTransporteri = "";
                      this.napomenaTransporteri += foundVozilo.Naziv + " (";
                      foundVozilo.RgBr ? this.napomenaTransporteri += "Registarski broj: " + foundVozilo.RgBr : "";
                      foundVozilo.VrstaVozila ? this.napomenaTransporteri += ", Vrsta vozila: " + foundVozilo.VrstaVozila : "";
      
                      let datum: string;
                      datum = foundVozilo.DatumReg
                          ? this.datePipe.transform(
                              new Date(foundVozilo.DatumReg["year"], foundVozilo.DatumReg["month"] - 1, foundVozilo.DatumReg["day"]),
                              'dd.MM.yyyy'
                          )
                          : "";
                      foundVozilo.DatumReg ? this.napomenaTransporteri += ", Datum registracije: " + datum : "";
                      foundVozilo.BrSbDozv ? this.napomenaTransporteri += ", Saobraćajna dozvola broj: " + foundVozilo.BrSbDozv : "";
                      foundVozilo.Marka ? this.napomenaTransporteri += ", Marka: " + foundVozilo.Marka : "";
                      foundVozilo.Model ? this.napomenaTransporteri += ", Model: " + foundVozilo.Model : "";
                      foundVozilo.BrojOsovina ? this.napomenaTransporteri += ", Broj osovina: " + foundVozilo.BrojOsovina : "";
                      foundVozilo.Masa ? this.napomenaTransporteri += ", Masa: " + foundVozilo.Masa : "";
                      foundVozilo.Nosivost ? this.napomenaTransporteri += ", Nosivost: " + foundVozilo.Nosivost : "";
                      foundVozilo.GodinaProizvodnje ? this.napomenaTransporteri += ", Godina proizvodnje: " + foundVozilo.GodinaProizvodnje : "";
                      foundVozilo.Boja ? this.napomenaTransporteri += ", Boja: " + foundVozilo.Boja : "";
                      foundVozilo.BrojSasije ? this.napomenaTransporteri += ", Broj šasije: " + foundVozilo.BrojSasije : "";
                      this.napomenaTransporteri += ")";
                      this.napomenaTransporteri += "\n";
                    }
                }
            });
    
            this.formGroup.get('NapomenaTransporteri').setValue(this.napomenaTransporteri);
            this.formGroup.get('NapomenaTransporteri').updateValueAndValidity();
        }

        this.brojVozila = this.trenutniBrojVozila;
    }
    

      VozilaItems;
      VozilaGetItems(items){
        this.VozilaItems = items;
      }

}
